import { schema } from 'normalizr';

export const distributorSchema = new schema.Entity('distributors', {}, { idAttribute: 'DistributorId' });
export const distributorListSchema = [distributorSchema];
